/**
 * Fetch options for the browser SDK transport (`transportOptions` in the
 * client `Sentry.init`).
 *
 * Telemetry is tunnelled through the same-origin `/monitoring` route, so by
 * default the browser attaches the app's full cookie jar (auth session,
 * Firebase, PostHog, marketing cookies) to every envelope POST. The Next.js
 * tunnel rewrite forwards those headers verbatim to `o*.ingest.*.sentry.io`,
 * whose nginx rejects oversized headers with "400 Request Header Or Cookie
 * Too Large" — silently dropping ALL client telemetry for any user whose
 * cookies exceed the limit (~8KB). Sentry never reads cookies, so omit
 * credentials to keep the forwarded request small. Fetch's default for
 * same-origin requests is `credentials: "same-origin"`, which is why the
 * tunnel is affected while direct cross-origin sends to sentry.io are not.
 */
export const CLIENT_TRANSPORT_OPTIONS = {
  fetchOptions: { credentials: "omit" },
} as const;
